//Include savings call out for higher counts

(function() {
  if (window.innerWidth < 768) return;

  // Discount tags are only accurate for the Dual Action PDP
  const showDiscounts = /\/products\/florastor-dual-action-probiotic-supplement\/?$/.test(window.location.pathname);

  const discounts = {
    '20': null,
    '30': '3% Off',
    '50': '19% Off',
    '100': '30% Off'
  };

  function updateDiscount() {
    if (!showDiscounts) return;
    console.log('updateDiscount called');
    
    // Remove existing tag
    const existingTag = document.querySelector('.discount-tag');
    if (existingTag) {
      existingTag.remove();
    }
    
    // Find the selected button (the one with dark background)
    const selectedButton = document.querySelector('button[data-option-value].bg-florastor-web-dark');
    console.log('Selected button:', selectedButton);
    
    if (!selectedButton) return;
    
    const optionValue = selectedButton.getAttribute('data-option-value');
    console.log('Option value:', optionValue);
    
    const match = optionValue.match(/(\d+)\s*ct/i);
    
    if (match) {
      const count = match[1];
      const discount = discounts[count];
      console.log('Count:', count, 'Discount:', discount);
      
      if (discount) {
        // Find the div with text-2xl class
        const priceDiv = document.querySelector('div.text-2xl');
        console.log('Price div found:', priceDiv);
        
        if (priceDiv) {
          const tag = document.createElement('span');
          tag.className = 'discount-tag';
          tag.textContent = `${discount} per capsule`;
          
          // Append to the div
          priceDiv.appendChild(tag);
          console.log('Tag appended');
        }
      }
    }
  }

  // Auto-select 100 ct on page load
  function autoSelect100ct() {
    const button100ct = document.querySelector('button[data-option-value="100 ct"]');
    if (button100ct) {
      button100ct.click();
      console.log('100 ct auto-selected');
    }
  }

  // Run on page load
  setTimeout(function() {
    autoSelect100ct();
    updateDiscount();
  }, 1000);
  
  // Run when buttons are clicked
  document.addEventListener('click', function(e) {
    if (e.target.closest('button[data-option-value]')) {
      setTimeout(updateDiscount, 100);
    }
  });
})();


